<template>
  <div class="progress-bar-container">
    <div class="progress-bar-background">
      <div class="progress-bar-text">
        <div v-if="groupTotal" class="question-group-progress">
          {{ groupProgress }}
        </div>

        <div class="question-remaining">
          {{ getPercentDisplayString(percentRemaining) }}
        </div>
      </div>
    </div>

    <div ref="progress-bar" :style="progressBarStyle" class="progress-bar td-200">
      <div class="progress-bar-text">
        <div v-if="groupTotal" class="question-group-progress">
          {{ groupProgress }}
        </div>

        <div class="question-remaining">
          {{ getPercentDisplayString(percentRemaining) }}
        </div>
      </div>
    </div>

    <transition name="slide-fade-left">
      <go-back-button v-if="current >= 1" @go-back="onClickGoBack" />
    </transition>
  </div>
</template>

<script>

import NoDragImage from '../common/NoDragImage';
import GoBackButton from '@/components/common/GoBackButton';

export default {
  name: 'AnimatingProgressBar',
  components: { GoBackButton, NoDragImage },
  props: {
    groupLabel: {
      type: String,
      required: false,
      default: null,
    },
    current: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    groupCurrent: {
      type: Number,
      required: false,
      default: null,
    },
    groupTotal: {
      type: Number,
      required: false,
      default: null,
    },
  },
  emits: ['animationStart', 'animationEnd', 'goBack'],
  computed: {
    progressBarStyle() {
      return {
        width: `${this.percentTotal}%`,
      };
    },
    percentTotal() {
      return this.normalizePercent(this.total > 0 ? (this.current / this.total) * 100 : 0);
    },
    percentRemaining() {
      return this.normalizePercent(100 - this.percentTotal);
    },
    groupProgress() {
      if (this.groupLabel) {
        return this.groupLabel;
      }

      return `Q${this.groupCurrent} / ${this.groupTotal}`;
    },
  },
  mounted() {
    const progressBar = this.$refs['progress-bar'];

    progressBar.addEventListener('transitionstart', this.onAnimationStart);
    progressBar.addEventListener('transitionend', this.onAnimationEnd);
  },
  unmounted() {
    const progressBar = this.$refs['progress-bar'];

    if (progressBar) {
      progressBar.removeEventListener('transitionstart', this.onAnimationStart);
      progressBar.removeEventListener('transitionend', this.onAnimationEnd);
    }
  },
  methods: {
    onClickGoBack() {
      this.$emit('goBack');
    },
    getPercentDisplay(percent) {
      return Math.round(percent);
    },
    getPercentDisplayString(percent) {
      const string = this.$t('question.remaining');

      return string.replace(/\[PERCENT\]/, this.getPercentDisplay(percent));
    },
    normalizePercent(percent) {
      return Math.max(0, Math.min(100, percent));
    },
    onAnimationStart() {
      this.$emit('animationStart', this.current);
    },
    onAnimationEnd() {
      this.$emit('animationEnd', this.current);
    },
  },
};
</script>

<style lang="scss" scoped>
$height: 25px;

.progress-bar-container {
  width: 100%;
  height: $height;
  margin-bottom: $height;
}

.progress-bar-background {
  background: #C7D3DA;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.progress-bar-text {
  width: 100vw;
  height: 100%;
  position: relative;
}

.progress-bar {
  background: #063C5A;
  line-height: $height;
  height: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;

  .question-group-progress,
  .question-remaining {
    //top: -3px;
    color: white;
  }
}

.question-group-progress,
.question-remaining {
  position: absolute;
  top: 0;
  color: #063C5A;
  font-size: 10pt;
  line-height: $height;
}

.question-group-progress {
  left: 5px;
}

.question-remaining {
  right: 5px;
}

.progress-bar {
  .question-group-progress,
  .question-remaining {
    color: white;
  }
}
</style>
